import type { SearchResponse } from '@algolia/client-search';

import type { SearchAlgoliaHit } from 'modules/search/algolia/types/SearchAlgoliaHit';
import { SearchResultsHeaderCount } from 'modules/search/components/Results/Header/SearchResultsHeaderCount';
import { SaveSearchButton } from 'modules/search/components/SaveSearch/SaveSearchButton';

import {
  ViewJobPageSidebarResultsHeaderHolder,
  ViewJobPageSidebarResultsHeaderLeftSide,
  ViewJobPageSidebarResultsHeaderRightSide,
  ViewJobPageSidebarResultsHeaderWrapper,
} from './ViewJobPageSidebarResultsHeader.styled';

type Props = {
  results: SearchResponse<SearchAlgoliaHit> | undefined;
  isSearching: boolean;
  saveSearch: () => Promise<void>;
};

export function ViewJobPageSidebarResultsHeader({
  results,
  isSearching,
  saveSearch,
}: Props) {
  return (
    <ViewJobPageSidebarResultsHeaderHolder>
      <ViewJobPageSidebarResultsHeaderWrapper>
        <ViewJobPageSidebarResultsHeaderLeftSide>
          <SearchResultsHeaderCount
            count={!isSearching && results ? results.nbHits! : null}
            searchType="JOB"
          />
        </ViewJobPageSidebarResultsHeaderLeftSide>
        <ViewJobPageSidebarResultsHeaderRightSide>
          <SaveSearchButton saveSearch={saveSearch} />
        </ViewJobPageSidebarResultsHeaderRightSide>
      </ViewJobPageSidebarResultsHeaderWrapper>
    </ViewJobPageSidebarResultsHeaderHolder>
  );
}
